(() => {
  const initAOS = () => {
    if (typeof AOS === 'undefined') return;

    AOS.init({
      once: true,
      duration: 600,
      easing: 'ease-out-cubic',
    });
  };

  const refreshAOS = () => {
    if (typeof AOS === 'undefined') return;
    AOS.refreshHard();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAOS, { once: true });
  } else {
    initAOS();
  }

  document.addEventListener('shopify:section:load', refreshAOS);
  document.addEventListener('shopify:section:reorder', refreshAOS);
  document.addEventListener('shopify:block:select', refreshAOS);
  document.addEventListener('shopify:block:deselect', refreshAOS);
})();
